// extracted by mini-css-extract-plugin
export default {"container":"style_container__uLSFW","score":"style_score__cy3ur"};